module.exports = __webpack_public_path__ + "static/Albertsons_pin-35b2fe1e045f4406b4a68765a0b4d315.png";